import { useNavigate } from "react-router-dom";
import { EntityManager } from "@/components/EntityManager";
import { ENTITY_CONFIG } from "@/lib/entities";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, Info } from "lucide-react";

export default function Expenses() {
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <Card className="p-4 flex flex-wrap items-start justify-between gap-3" data-testid="expenses-sop-note">
        <div className="flex items-start gap-2.5 min-w-0">
          <Info className="h-4 w-4 text-brand mt-0.5 shrink-0" />
          <p className="text-xs text-muted-foreground max-w-2xl">
            This ledger shows every expense, including accruals created from uploaded invoices. A bill
            that has an invoice must be entered in <span className="text-foreground">Vendors Payable</span>,
            and paid from <span className="text-foreground">Bank Reconciliation</span> — entering it
            here as well would double-count the P&amp;L, so it is blocked. Add directly here only for
            entries with no invoice and no bank line.
          </p>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => navigate("/sop")}
          className="gap-1.5 text-muted-foreground hover:text-foreground shrink-0"
          data-testid="expenses-sop-link"
        >
          Read the SOP
          <ArrowRight className="h-3.5 w-3.5" />
        </Button>
      </Card>
      <EntityManager config={ENTITY_CONFIG.expenses} />
    </div>
  );
}
